import { ISettingsItem } from './ISettingsItem';
import { ContentTransferSettingsItem } from './items/ContentTransferSettingsItem';
import { IntegrationSettingsItem } from './items/IntegrationSettingsItem';
import { SpecificationSettingsItem } from './items/SpecificationSettingsItem';
import { SSOSettingsItem } from './items/SSOSettingsItem';
import { UserSettingsItem } from './items/UserSettingsItem';

export const SettingsPageTree: { [name: string]: ISettingsItem } = {
  specification: SpecificationSettingsItem,
  integration: IntegrationSettingsItem,
  user: UserSettingsItem,
  contentTransfer: ContentTransferSettingsItem,
  sso: SSOSettingsItem,
};
